import React from "react";
import TextField from "@material-ui/core/TextField";

export default function CustomTextField(props) {
	const { handleChange, value, data } = props;
	const { label, required, id, multiline = false, tooltip = "" } = data;

	return (
		<TextField
			fullWidth
			name={id}
			multiline={multiline}
			label={label}
			value={value}
			onChange={handleChange}
			required={required}
			helperText={tooltip}
		/>
	);
}
